import { TagLabel } from "@draftkings/arena-web";
import * as React from "react";
export const EarlyWinSelectionTag = React.memo(function EarlyWinSelectionTag(props) {
    const { tag, testId } = props;
    const variant = tag.variant === "filled"
        ? "earlyWin:Active"
        : "earlyWin:Inactive";
    return (React.createElement(TagLabel, { testId: testId, as: "span", variant: variant, "aria-label": tag.label }, tag.label));
});
//# sourceMappingURL=EarlyWinSelectionTag.js.map